(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawbau-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pawbau-announcements')) {
    customElements.define(
      'pawbau-announcements',
      class extends HTMLElement {
        connectedCallback() {
          this.lines = [...this.querySelectorAll('.pawbau-bar__line')];
          if (this.lines.length < 2) return;
          this.at = 0;
          this.fade = Number(this.dataset.fade) || 260;
          this.timer = setInterval(() => this.next(), Number(this.dataset.every) || 4000);
          // a line someone is reading stays put
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          clearTimeout(this.swap);
        }

        /** The line leaving goes first, alone: two lines are never readable at the same time. */
        next() {
          if (this.paused || document.hidden || this.swap) return;
          const going = this.lines[this.at];
          going.classList.remove('is-on');
          going.classList.add('is-off');
          this.at = (this.at + 1) % this.lines.length;
          // un filo piu della dissolvenza: cosi la riga che esce e gia sparita, non quasi
          this.swap = setTimeout(() => {
            going.classList.remove('is-off');
            this.lines[this.at].classList.add('is-on');
            this.swap = 0;
          }, this.fade + 60);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawbau-track-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('pawbau-track-order')) return;

    // received → production / shaping → finishing / preparing → usps → delivered. The trip to the US is never
    // shown as travel: it reads as the last steps of the work, until USPS scans the parcel.
    const STEP = { received: 0, production: 1, shaping: 1, finishing: 2, preparing: 2, usps: 3, delivered: 4 };
    const STEPS = ['Order received', 'Handmade', 'Final touches', 'Shipped', 'Delivered'];
    const PIECES = ['necklace', 'bracelet', 'keychain'];
    // the finishes as the configurator draws them, and its cords
    const DRAWN = { Silver: '#8E959B', Gold: '#C39A52', 'Rose Gold': '#CE9486', Black: '#1C1C1E' };
    const CORDS = { Black: '#20201F', Ivory: '#EFE7D6', 'Army Green': '#4B5320', Burgundy: '#6E1A2B' };
    const DAY = 86400000;
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const PAW = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="12" cy="16.2" rx="5" ry="4.3"/>' +
      '<ellipse cx="5.6" cy="10.4" rx="2" ry="2.5"/><ellipse cx="9.4" cy="6.6" rx="2" ry="2.6"/>' +
      '<ellipse cx="14.6" cy="6.6" rx="2" ry="2.6"/><ellipse cx="18.4" cy="10.4" rx="2" ry="2.5"/></svg>';

    class PawbauTrackOrder extends HTMLElement {
      connectedCallback() {
        this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
        try {
          this.shop = JSON.parse(this.querySelector('[data-shop]').textContent);
        } catch {
          this.shop = { pieces: {} };
        }
        this.form = this.querySelector('form');
        this.top = this.querySelector('.pawbau-home__top');
        this.result = this.querySelector('.pawbau-track__result');
        this.button = this.form.querySelector('button');
        this.again = this.querySelector('.pawbau-track__again');
        this.previews = new Map();
        // ?order=44380 fills the number in; ?order=44380&t=<code> (a link from customer care or from our emails)
        // opens the order straight away, without the form
        const params = new URLSearchParams(location.search);
        // ?order=#44406 (Judge.me's {{ order_name }} in our emails): the browser keeps "#44406" apart, as the hash
        const order = params.get('order') || (location.hash.match(/^#([A-Za-z0-9]{3,20})$/) || [])[1];
        // the # is drawn in the box: one typed or pasted anyway goes, and so do spaces
        const bare = (value) => value.replace(/[#\s]/g, '');
        this.form.order.addEventListener('input', () => {
          const clean = bare(this.form.order.value);
          if (clean !== this.form.order.value) this.form.order.value = clean;
        });
        if (order) this.form.order.value = bare(order);
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.token = null;
          this.lookup();
        });
        this.again.querySelector('button').addEventListener('click', () => this.reset());
        if (order && params.get('t')) {
          this.token = params.get('t');
          this.form.hidden = true;
          this.lookup();
        } else if (this.dataset.endpoint) {
          // wakes the web app up while the customer types: the first answer after a pause is the slow one
          fetch(this.dataset.endpoint).catch(() => {});
        }
      }

      disconnectedCallback() {
        clearInterval(this.clock);
      }

      async ask(body, wait, tries) {
        let answer = { ok: false, error: 'unavailable' };
        // an answer usually takes 2-5 seconds; one that hangs is dropped and asked again
        for (let attempt = 0; attempt < tries; attempt++) {
          const timer = new AbortController();
          const stop = setTimeout(() => timer.abort(), wait);
          try {
            // text/plain keeps it a simple request: no preflight, which Apps Script cannot answer
            const res = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify(body),
              signal: timer.signal,
            });
            answer = await res.json();
            break;
          } catch {
            answer = { ok: false, error: 'unavailable' };
          } finally {
            clearTimeout(stop);
          }
        }
        return answer;
      }

      async lookup() {
        const order = this.form.order.value.trim();
        const email = this.form.email.value.trim();
        if (!this.token && (!order || !email)) return this.form.reportValidity();
        if (!this.dataset.endpoint) return this.show(this.message('unavailable'));
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        const stopLoading = this.loading(this.copy.loading);
        // #add is the button in the order confirmation email: the dashboard counts the orders it brings
        const src = location.hash === '#add' ? 'email' : this.token ? 'link' : 'form';
        const answer = await this.ask(this.token ? { order, token: this.token, src } : { order, email, src }, 15000, 3);
        stopLoading();
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        if (!answer.ok) {
          // a link that no longer works falls back to the form
          if (this.token) this.form.hidden = false;
          return this.show(this.message(answer.error));
        }
        this.answer = answer;
        this.token = answer.token || this.token;
        // the answer takes the page: the form and the headline step aside until "Track another order"
        this.form.hidden = true;
        if (this.top) this.top.hidden = true;
        this.again.hidden = false;
        this.show(this.order(answer));
        if (location.hash === '#add' || location.hash === '#mia') this.querySelector('.pawbau-track__box')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      reset() {
        clearInterval(this.clock);
        this.answer = null;
        this.token = null;
        this.result.hidden = true;
        this.result.replaceChildren();
        this.form.hidden = false;
        if (this.top) this.top.hidden = false;
        this.again.hidden = true;
        this.form.order.value = '';
        this.form.order.focus();
      }

      show(node) {
        this.result.replaceChildren(node);
        this.result.hidden = false;
        this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      // paw prints walking across, and a line that changes every couple of seconds
      loading(text, into) {
        const box = el('div', 'pawbau-track__loading');
        const paws = el('div', 'pawbau-track__paws');
        paws.setAttribute('aria-hidden', 'true');
        for (let i = 0; i < 4; i++) {
          const paw = el('span', 'pawbau-track__paw');
          paw.style.setProperty('--i', i);
          paw.innerHTML = PAW;
          paws.append(paw);
        }
        const line = el('p', 'pawbau-track__loading-line');
        const lines = String(text || '').split('\n').map((s) => s.trim()).filter(Boolean);
        let n = 0;
        line.textContent = lines[0] || '';
        box.append(paws, line);
        if (into) into.replaceChildren(box);
        else this.show(box);
        const turn = setInterval(() => {
          if (lines.length < 2) return;
          n = Math.min(n + 1, lines.length - 1);   // the last line stays until the answer
          line.classList.remove('is-in');
          void line.offsetWidth;
          line.textContent = lines[n];
          line.classList.add('is-in');
        }, 1800);
        return () => clearInterval(turn);
      }

      message(error) {
        const p = el('p', 'pawbau-track__message');
        p.textContent = this.copy[error] || this.copy.unavailable;
        return p;
      }

      // — the order —————————————————————————————————————————————

      order(a) {
        const box = el('div', 'pawbau-track__order');
        const own = a.pieces.filter((p) => !p.remake && p.stage !== 'cancelled');
        const remakes = a.pieces.filter((p) => p.remake && p.stage !== 'cancelled');
        // not in the sheet yet (or from before October): Shopify's stage speaks for the order
        const pieces = own.length ? own : a.pieces.length ? [] : [{ stage: a.stage, tracking: a.tracking || [] }];

        const meta = el('div', 'pawbau-track__meta');
        meta.append(text('p', '', `Order ${a.order}`), text('p', '', this.summary(a, own)));
        box.append(meta);

        const live = pieces.filter((p) => p.stage in STEP);
        if (a.stage === 'cancelled' || (!live.length && !remakes.length)) {
          box.append(this.message(a.stage === 'cancelled' ? 'cancelled' : a.pieces.length ? 'cancelled' : 'unknown'));
          return box;
        }
        if (live.length) {
          const problem = live.map((p) => p.problem).find(Boolean);
          box.append(text('h3', 'pawbau-track__when', problem ? this.copy.problem_head : this.when(a, live)));
          box.append(this.timeline(a, live));
          if (problem) box.append(this.problem(problem));
        }
        remakes.forEach((p) => {
          const card = el('section', 'pawbau-track__remake');
          const title = text('p', 'pawbau-track__remake-title', [p.product, p.pet && `for ${p.pet}`].filter(Boolean).join(' '));
          title.append(' ', text('span', 'pawbau-track__tag', 'Replacement'));
          card.append(title, this.timeline(a, [p], true));
          if (p.problem) card.append(this.problem(p.problem));
          box.append(card);
        });
        if (a.joined) box.append(text('p', 'pawbau-track__note', this.copy.joined.replace('[order]', a.joined)));
        if (this.offering(a)) box.append(this.offer(a));
        return box;
      }

      // "Queenie · keychain + gift box"
      summary(a, own) {
        const pets = a.pets || [];
        let line = pets.length
          ? pets.map((p) => `${p.name || p.label} · ${p.pieces.map((x) => x.piece).join(' + ')}`).join(', ')
          : own.map((p) => [p.pet, p.product.toLowerCase()].filter(Boolean).join(' · ')).join(', ');
        if (a.gifts) line += ` + ${a.gifts > 1 ? `${a.gifts} gift boxes` : 'gift box'}`;
        return line;
      }

      // "Arrives Nov 11 – 14", "Delivered Oct 21"
      when(a, live) {
        if (live.every((p) => p.stage === 'delivered')) {
          const last = live.map((p) => p.at).filter(Boolean).pop();
          return last ? this.copy.delivered_head.replace('[date]', last) : STEPS[4];
        }
        const placed = new Date(a.placedAt || a.placed || Date.now());
        const days = Number(this.shop.days) || 16;
        const holidays = new Set(String(this.shop.holidays || '').split(',').map((d) => d.trim()).filter(Boolean));
        const start = shopDay(placed, this.shop.zone);
        const to = nextWorking(start + days * DAY, holidays);
        const from = nextWorking(start + Math.max(days - 3, 1) * DAY, holidays);
        if (Date.now() > to + DAY) return this.copy.arriving;
        return this.copy.arrives.replace('[dates]', range(from, to));
      }

      // One line of steps for the whole order: the piece furthest behind sets where it is.
      timeline(a, pieces, small) {
        const at = Math.min(...pieces.map((p) => STEP[p.stage]));
        const lead = pieces.find((p) => STEP[p.stage] === at);
        const tracking = [];
        pieces.forEach((p) => (p.tracking || []).forEach((t) => {
          if (!tracking.some((x) => x.number === t.number)) tracking.push(t);
        }));
        const dates = [
          small ? '' : String(a.placed || '').replace(/,\s*\d{4}$/, ''),
          '',
          '',
          pieces.map((p) => p.shipped).find(Boolean) || '',
          pieces.every((p) => p.stage === 'delivered') ? pieces.map((p) => p.at).filter(Boolean).pop() || '' : '',
        ];
        const list = el('ol', `pawbau-track__line${small ? ' pawbau-track__line--small' : ''}`);
        STEPS.forEach((label, i) => {
          const li = el('li', 'pawbau-track__step');
          const done = i < at || (i === at && lead.stage === 'delivered');
          if (done) li.classList.add('is-done');
          if (i === at && !done) {
            li.classList.add('is-current');
            li.setAttribute('aria-current', 'step');
          }
          const head = text('p', 'pawbau-track__step-name', label);
          if (i === at && !done) head.append(' ', text('span', 'pawbau-track__now', 'Now'));
          li.append(head);
          if (dates[i] && (done || i === at)) li.append(text('p', 'pawbau-track__step-date', dates[i]));
          if (i === at && !done) {
            // a delivery issue has its own note under the timeline
            const words = lead.problem ? '' : lead.stage === 'received' && a.window ? this.copy.received_box : this.copy[lead.stage];
            if (words) li.append(text('p', 'pawbau-track__step-text', words));
            // two pieces at different steps: say where the other ones are
            pieces.filter((p) => p !== lead && p.stage !== lead.stage).forEach((p) => {
              li.append(text('p', 'pawbau-track__step-text', `${[p.product, p.pet && `for ${p.pet}`].filter(Boolean).join(' ')}: ${STEPS[STEP[p.stage]]}`));
            });
          }
          if (i === 3 && tracking.length) li.append(links(tracking));
          else if (i === 3 && i > at && !small) li.append(text('p', 'pawbau-track__step-text', this.copy.tracking_soon));
          list.append(li);
        });
        return list;
      }

      // USPS couldn't deliver: what it said, and how to reach it (the delivery is between the customer and USPS now)
      problem(p) {
        const carrier = p.carrier || 'your carrier';
        const day = new Date(`${p.day}T12:00:00Z`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', timeZone: 'UTC' });
        const fill = (words) => String(words || '').replace(/\[carrier\]/g, carrier).replace(/\[date\]/g, day);
        const box = el('section', 'pawbau-track__problem');
        box.setAttribute('role', 'alert');
        box.append(text('p', 'pawbau-track__problem-title', fill(this.copy.problem_title)));
        box.append(text('p', 'pawbau-track__problem-text', fill(this.copy['problem_' + p.kind] || this.copy.problem_attempt)));
        if (p.says) box.append(text('p', 'pawbau-track__says', `${fill(this.copy.problem_says)} “${p.says}”`));
        box.append(text('p', 'pawbau-track__problem-text', fill(this.copy.problem_contact)));
        const ways = el('ul', 'pawbau-track__contacts');
        const way = (label, value, href) => {
          const li = el('li');
          const link = text('a', '', value);
          link.href = href;
          if (/^https?:/.test(href)) {
            link.target = '_blank';
            link.rel = 'noopener';
          }
          li.append(text('span', 'pawbau-track__contact-label', label), link);
          ways.append(li);
        };
        if (p.phone) way(fill(this.copy.problem_call), p.phone, 'tel:' + p.phone.replace(/[^\d+]/g, ''));
        if (p.email) way(fill(this.copy.problem_email), p.email, 'mailto:' + p.email);
        if (p.url) way(fill(this.copy.problem_track), [p.carrier, p.number].filter(Boolean).join(' '), p.url);
        box.append(ways);
        return box;
      }

      // — the same box ——————————————————————————————————————————

      offering(a) {
        return this.shop.offer !== false && !a.joined && (a.pets || []).length > 0 && this.token &&
          Object.keys(this.shop.pieces || {}).length > 0;
      }

      offer(a) {
        this.basket = { items: [], gifts: new Set(), warranty: false };
        this.chat = this.fromChat(a);
        const wrap = el('section', 'pawbau-track__box');
        wrap.id = 'add';
        this.box = wrap;
        this.drawOffer(a);
        clearInterval(this.clock);
        if (a.window) {
          // the pill counts down; when the window closes the offer turns into its after-the-window version
          this.clock = setInterval(() => {
            const time = wrap.querySelector('.pawbau-track__time');
            const left = new Date(a.window.until) - Date.now();
            if (left <= 0) {
              clearInterval(this.clock);
              delete a.window;
              this.drawOffer(a);
            } else if (time) time.textContent = duration(left);
          }, 20000);
        }
        return wrap;
      }

      get together() {
        return Boolean(this.answer?.window && new Date(this.answer.window.until) > Date.now());
      }

      drawOffer(a) {
        const wrap = this.box;
        const together = this.together;
        const price = Math.round(a.price * 100);
        const fill = (s) => String(s || '').replace('[price]', this.money(price)).replace('[shipping]', this.money(Math.round(a.shipping * 100)));
        wrap.replaceChildren();
        wrap.classList.toggle('is-later', !together);

        // the hero: the time left, the price, no shipping, and one more of their own piece for each pet
        const hero = el('div', 'pawbau-track__hero');
        const title = el('h3', 'pawbau-track__hero-title');
        if (together) {
          const [before, after = ''] = String(this.copy.box_title).split('[time]');
          const time = text('span', 'pawbau-track__time', duration(new Date(a.window.until) - Date.now()));
          title.append(before, time, after);
        } else {
          title.textContent = this.copy.later_title;
        }
        const badges = el('div', 'pawbau-track__badges');
        const gold = el('span', 'pawbau-track__gold');
        gold.append(`${this.copy.price_label} `, text('b', '', this.money(price)));
        const list = Math.max(...Object.values(this.shop.pieces).map((x) => x.price));
        if (list > price) gold.append(' ', text('s', '', this.money(list)));
        const ship = el('span', 'pawbau-track__ship');
        ship.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
        ship.append(fill(together ? this.copy.box_ship : this.copy.later_ship));
        badges.append(gold, ship);
        hero.append(title, badges);

        // what was added on top of the offer: more of their own piece, pets made with Mia
        const added = el('div', 'pawbau-track__cards pawbau-track__cards--added');
        const own = el('div', 'pawbau-track__own');
        a.pets.slice(0, 3).forEach((pet, k) => {
          const same = pet.pieces[0]?.piece;
          if (!same || !this.shop.pieces[same]) return;
          const more = el('button', 'pawbau-track__own-add');
          more.type = 'button';
          const plus = text('span', 'pawbau-track__own-plus', '+');
          plus.setAttribute('aria-hidden', 'true');
          const words = text('span', 'pawbau-track__own-words', this.copy.another.replace('[piece]', same).replace('[name]', pet.name || `your ${pet.label}`));
          const count = el('span', 'pawbau-track__own-count');
          const paint = () => {
            const n = this.basket.items.filter((it) => it.extra && !it.chat && it.pet === k).length;
            count.textContent = n ? `${n} added ✓` : this.money(price);
            more.classList.toggle('is-on', n > 0);
          };
          more.append(plus, words, count);
          more.addEventListener('click', () => {
            const it = this.item(a, k, same, `x:${Date.now()}`);
            it.on = true;
            it.extra = true;
            it.done = paint;
            this.basket.items.push(it);
            this.prepare(a, it);
            added.prepend(this.card(a, it));
            paint();
            this.tally(a);
          });
          paint();
          own.append(more);
        });
        if (own.children.length) hero.append(own);
        wrap.append(hero);

        this.basket.items.filter((it) => it.extra && !it.chat).forEach((it) => added.append(this.card(a, it)));
        this.chat.forEach((it) => {
          if (!this.basket.items.includes(it)) this.basket.items.push(it);
          added.append(this.card(a, it));
        });
        wrap.append(added);

        // the same pets on the pieces they don't have yet
        const offers = [];
        a.pets.slice(0, 3).forEach((pet, k) => {
          const have = new Set(pet.pieces.map((x) => x.piece));
          PIECES.filter((p) => !have.has(p) && this.shop.pieces[p]).forEach((piece) => offers.push({ pet: k, piece }));
        });
        if (offers.length) {
          const grid = el('div', 'pawbau-track__cards');
          offers.slice(0, 4).forEach((o) => grid.append(this.card(a, this.item(a, o.pet, o.piece, `o:${o.pet}:${o.piece}`))));
          wrap.append(text('p', 'pawbau-track__subhead', this.copy.more_title), grid);
        }

        const rows = el('div', 'pawbau-track__rows');
        // a box for a piece already ordered: only while it can still be packed with it
        if (together && this.shop.gift) {
          a.pets.forEach((pet, k) => {
            const bare = pet.pieces.find((x) => !x.gift);
            if (!bare) return;
            const label = this.copy.gift_for.replace('[name]', pet.name || `your ${pet.label}`).replace('[piece]', bare.piece);
            rows.append(this.toggle(label, this.money(this.shop.gift), '', this.basket.gifts.has(k), (on) => {
              if (on) this.basket.gifts.add(k);
              else this.basket.gifts.delete(k);
              this.tally(a);
            }, 'gift'));
          });
        }
        if (!a.warranty && this.shop.warranty) {
          rows.append(this.toggle(this.copy.warranty_title, this.money(this.shop.warranty), this.copy.warranty_line, this.basket.warranty, (on) => {
            this.basket.warranty = on;
            this.tally(a);
          }, 'shield'));
        }
        // a pet the order does not have: Mia draws it, the piece comes back here
        const pet = el('div', 'pawbau-track__row pawbau-track__row--pet');
        const words = el('div', 'pawbau-track__row-words');
        words.append(text('p', 'pawbau-track__row-title', this.copy.pet_title), text('p', 'pawbau-track__row-line', fill(this.copy.pet_line)));
        const link = text('a', 'pawbau-track__pet-link', this.copy.pet_button);
        const no = String(a.order).replace('#', '');
        link.href = `${this.shop.chat}?pb_add=${encodeURIComponent(no)}&pb_t=${encodeURIComponent(this.token)}${together ? '&pb_box=1' : ''}`;
        pet.append(icon('paw'), words, link);
        rows.append(pet);
        wrap.append(rows);

        const bar = el('div', 'pawbau-track__bar');
        const sum = el('div', 'pawbau-track__bar-sum');
        sum.setAttribute('aria-live', 'polite');
        const go = el('button', 'button pawbau-track__go');
        go.type = 'button';
        go.textContent = together ? this.copy.button_box : this.copy.button_later;
        go.addEventListener('click', () => this.buy(a));
        bar.append(sum, go);
        const status = el('p', 'pawbau-track__bar-status');
        status.hidden = true;
        wrap.append(bar, status);
        this.tally(a);
      }

      // a piece of the basket: the same pet (`pet` is its place in the order) on `piece`
      item(a, k, piece, key) {
        const found = this.basket.items.find((it) => it.key === key);
        if (found) return found;
        const pet = a.pets[k];
        const shop = this.shop.pieces[piece];
        const finishes = buyable(shop);
        const finish = finishes.includes(pet.finish) ? pet.finish : finishes[0] || '';
        const cord = piece === 'bracelet' ? shop.cord.find((c) => !(shop.sold || []).includes(`${finish} / ${c}`)) || '' : '';
        return { key, pet: k, who: pet, piece, finish, cord, gift: false, on: false };
      }

      // pieces made in the chat for this order, waiting in this tab (the configurator's #backToOrder)
      fromChat(a) {
        const key = `pb_add:${String(a.order).replace('#', '')}`;
        try {
          return JSON.parse(sessionStorage.getItem(key) || '[]').filter((c) => c && c.pet && this.shop.pieces[c.piece]).map((c, i) => ({
            key: `c:${i}`, custom: c.pet, who: c.pet, piece: c.piece, finish: c.finish, cord: c.cord, gift: Boolean(c.gift), on: true, extra: true, chat: true,
          }));
        } catch {
          return [];
        }
      }

      dropChat(a, it) {
        const key = `pb_add:${String(a.order).replace('#', '')}`;
        this.chat = this.chat.filter((c) => c !== it);
        try {
          const kept = JSON.parse(sessionStorage.getItem(key) || '[]').filter((_, i) => `c:${i}` !== it.key);
          sessionStorage.setItem(key, JSON.stringify(kept));
        } catch {}
      }

      card(a, it) {
        const shop = this.shop.pieces[it.piece];
        const card = el('article', `pawbau-track__card${it.extra ? ' is-extra' : ''}`);
        const art = el('div', 'pawbau-track__art');
        card.append(art);
        this.draw(art, it);
        const who = it.who.name || `Your ${it.who.label}`;
        card.append(text('p', 'pawbau-track__card-title', `${who} on ${it.extra && !it.chat ? 'another' : 'a'} ${it.piece}`));
        const price = el('p', 'pawbau-track__card-price');
        const tag = el('span', 'pawbau-track__gold pawbau-track__gold--small');
        tag.append(text('b', '', this.money(Math.round(a.price * 100))));
        if (shop.price > a.price * 100) tag.append(' ', text('s', '', this.money(shop.price)));
        price.append(tag);
        card.append(price);

        const pick = el('div', 'pawbau-track__pick');
        const button = el('button', 'pawbau-track__add');
        button.type = 'button';
        const paint = () => {
          card.classList.toggle('is-on', it.on);
          button.setAttribute('aria-pressed', String(it.on));
          button.textContent = it.on ? (it.extra ? 'Remove' : 'Added ✓') : 'Add';
          pick.hidden = !it.on;
        };
        button.addEventListener('click', () => {
          if (it.extra) {
            this.basket.items = this.basket.items.filter((x) => x !== it);
            if (it.chat) this.dropChat(a, it);
            card.remove();
            it.done?.();
            return this.tally(a);
          }
          it.on = !it.on;
          if (it.on && !this.basket.items.includes(it)) this.basket.items.push(it);
          if (it.on) this.prepare(a, it);
          paint();
          this.tally(a);
        });
        if (!this.basket.items.includes(it)) this.basket.items.push(it);

        // the finish (and the cord of a bracelet), then the box
        const chips = (label, values, current, set, colours) => {
          if (values.length < 2) return;
          const row = el('div', 'pawbau-track__chips');
          row.setAttribute('role', 'radiogroup');
          row.setAttribute('aria-label', label);
          values.forEach((v) => {
            const chip = el('button', 'pawbau-track__chip');
            chip.type = 'button';
            chip.setAttribute('role', 'radio');
            chip.setAttribute('aria-checked', String(v === current()));
            chip.title = v;
            chip.setAttribute('aria-label', v);
            chip.style.setProperty('--chip', colours[v] || '#ccc');
            chip.addEventListener('click', () => {
              set(v);
              row.querySelectorAll('button').forEach((b) => b.setAttribute('aria-checked', String(b.title === v)));
              this.draw(art, it);
              this.prepare(a, it);
            });
            row.append(chip);
          });
          pick.append(row);
        };
        chips('Finish', buyable(shop), () => it.finish, (v) => { it.finish = v; }, DRAWN);
        if (it.piece === 'bracelet') chips('Cord', shop.cord, () => it.cord, (v) => { it.cord = v; }, CORDS);
        if (this.shop.gift) {
          const gift = el('label', 'pawbau-track__gift');
          const box = document.createElement('input');
          box.type = 'checkbox';
          box.checked = it.gift;
          box.addEventListener('change', () => {
            it.gift = box.checked;
            this.tally(a);
          });
          gift.append(box, ` ${this.copy.gift_with.replace('[price]', this.money(this.shop.gift))}`);
          pick.append(gift);
        }
        card.append(button, pick);
        paint();
        return card;
      }

      toggle(title, price, line, on, change, kind) {
        const row = el('label', 'pawbau-track__row');
        const words = el('span', 'pawbau-track__row-words');
        words.append(text('span', 'pawbau-track__row-title', `${title} · ${price}`));
        if (line) words.append(text('span', 'pawbau-track__row-line', line));
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'pawbau-track__switch';
        input.checked = on;
        input.setAttribute('role', 'switch');
        input.addEventListener('change', () => change(input.checked));
        row.append(icon(kind), words, input);
        return row;
      }

      // what the bar says: how many pieces, how much, and the shipping
      tally(a) {
        const wrap = this.box;
        const bar = wrap.querySelector('.pawbau-track__bar');
        const sum = wrap.querySelector('.pawbau-track__bar-sum');
        if (!bar) return;
        const picked = this.basket.items.filter((it) => it.on);
        const together = this.together;
        const cents = picked.length * Math.round(a.price * 100) +
          (picked.filter((it) => it.gift).length + (together ? this.basket.gifts.size : 0)) * (this.shop.gift || 0) +
          (this.basket.warranty ? this.shop.warranty || 0 : 0) + (together || !picked.length ? 0 : Math.round(a.shipping * 100));
        this.ready = null;
        const things = picked.length ? `${picked.length} ${picked.length > 1 ? 'pieces' : 'piece'}` : this.basket.gifts.size || this.basket.warranty ? 'Your extras' : '';
        bar.hidden = !things;
        if (!things) return;
        const fill = (s) => String(s || '').replace('[shipping]', this.money(Math.round(a.shipping * 100)));
        sum.replaceChildren(text('p', 'pawbau-track__bar-total', `${things} · ${this.money(cents)}`));
        if (picked.length) sum.append(text('p', 'pawbau-track__bar-ship', fill(together ? this.copy.bar_free : this.copy.bar_paid)));
      }

      // the file for a piece, asked of the engine as soon as it is chosen: when the order sheet asks for the same
      // one a moment later, it is already made
      prepare(a, it) {
        clearTimeout(it.wait);
        it.wait = setTimeout(() => {
          const w = it.who;
          const colour = (DRAWN[it.finish] || '#1C1C1C').slice(1).toLowerCase();
          fetch(`${this.shop.engine}/prepare?breed=${encodeURIComponent(w.breed)}&name=${encodeURIComponent(w.name || '')}&colour=${colour}&piece=${it.piece}${w.halo ? '&halo=1' : ''}`).catch(() => {});
        }, 700);
      }

      async buy(a) {
        const picked = this.basket.items.filter((it) => it.on);
        const add = {
          items: picked.map((it) => Object.assign(it.custom ? { custom: { name: it.custom.name || '', breed: it.custom.breed, label: it.custom.label, halo: Boolean(it.custom.halo) } } : { pet: it.pet },
            { piece: it.piece, finish: it.finish, cord: it.cord, gift: it.gift })),
          gifts: this.together ? [...this.basket.gifts] : [],
          warranty: this.basket.warranty,
        };
        if (!add.items.length && !add.gifts.length && !add.warranty) return;
        const wrap = this.box;
        const status = wrap.querySelector('.pawbau-track__bar-status');
        const go = wrap.querySelector('.pawbau-track__go');
        // the window closed while they chose: say it before the invoice does
        if (this.ready) {
          location.href = this.ready;
          return;
        }
        go.disabled = true;
        go.setAttribute('aria-busy', 'true');
        status.hidden = false;
        const stop = this.loading(this.copy.adding, status);
        const answer = await this.ask({ order: String(a.order).replace('#', ''), token: this.token, add }, 60000, 2);
        stop();
        go.disabled = false;
        go.removeAttribute('aria-busy');
        if (!answer.ok || !answer.url) {
          status.replaceChildren(text('p', 'pawbau-track__bar-error', answer.error === 'locked' ? this.copy.locked : this.copy.add_failed));
          return;
        }
        try {
          sessionStorage.removeItem(`pb_add:${String(a.order).replace('#', '')}`);
        } catch {}
        if (add.items.length && this.answer.window && !answer.together) {
          this.ready = answer.url;
          status.replaceChildren(text('p', 'pawbau-track__bar-error', this.copy.box_closed.replace('[shipping]', this.money(Math.round(a.shipping * 100)))));
          go.textContent = this.copy.button_later;
          return;
        }
        location.href = answer.url;
      }

      // their charm on the piece: the engine's drawing, in the finish chosen
      async draw(art, it) {
        const w = it.who;
        const key = `${w.breed}|${w.name || ''}|${w.halo ? 1 : 0}`;
        if (!this.previews.has(key)) {
          this.previews.set(key, fetch(`${this.shop.engine}/preview?breed=${encodeURIComponent(w.breed)}&name=${encodeURIComponent(w.name || '')}${w.halo ? '&halo=1' : ''}`)
            .then((r) => (r.ok ? r.json() : null)).catch(() => null));
        }
        const shape = await this.previews.get(key);
        art.replaceChildren(scene(shape, it.piece, DRAWN[it.finish] || '#C39A52', CORDS[it.cord] || CORDS.Black, w.image));
      }

      money(cents) {
        const format = this.shop.money || '${{amount}}';
        // $29.90, but $59 and $15: whole dollars read better without their cents
        const amount = (Number(cents) / 100).toFixed(2).replace(/\.00$/, '');
        return format.replace(/\{\{\s*amount\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
      }
    }

    // — drawing ————————————————————————————————————————————————

    // The charm hanging from its piece in a 200×150 frame: from a chain for the necklace, from a ring for the keychain,
    // tied at both sides to the cord for the bracelet. Without the engine's drawing, the cart picture of their charm,
    // or a paw.
    function scene(shape, piece, metal, cord, image) {
      const svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 200 150');
      svg.setAttribute('aria-hidden', 'true');
      const bracelet = piece === 'bracelet';
      const area = bracelet ? { y: 36, w: 112, h: 78 } : { y: piece === 'keychain' ? 46 : 34, w: 118, h: piece === 'keychain' ? 96 : 106 };
      let w = 1, h = 1;
      if (shape && shape.viewBox) [, , w, h] = shape.viewBox.split(/\s+/).map(Number);
      const k = Math.min(area.w / w, area.h / h);
      const charm = { x: 100 - (w * k) / 2, y: area.y + (area.h - h * k) / 2, w: w * k, h: h * k };
      const ring = (cx, cy, r) => draw(svg, 'circle', { cx, cy, r, fill: 'none', stroke: metal, 'stroke-width': 1.8 });
      if (piece === 'necklace') {
        const at = charm.y - 4;
        draw(svg, 'path', { d: `M10 2 Q58 ${at - 2} 100 ${at} Q142 ${at - 2} 190 2`, fill: 'none', stroke: metal, 'stroke-width': 2, 'stroke-dasharray': '2.6 2', 'stroke-linecap': 'round' });
        ring(100, at + 2, 3);
      } else if (piece === 'keychain') {
        draw(svg, 'circle', { cx: 100, cy: 19, r: 14, fill: 'none', stroke: metal, 'stroke-width': 3.2 });
        draw(svg, 'path', { d: `M100 33 V${charm.y - 5}`, stroke: metal, 'stroke-width': 2.2, 'stroke-dasharray': '3 2' });
        ring(100, charm.y - 2, 3);
      } else {
        const mid = charm.y + charm.h * 0.42;
        const left = charm.x - 3, right = charm.x + charm.w + 3;
        // an edge a shade darker and a braid a shade lighter: a pale cord still reads on the pale panel
        [`M3 ${mid + 10} Q${left / 2} ${mid} ${left - 4} ${mid}`, `M${right + 4} ${mid} Q${(right + 200) / 2} ${mid} 197 ${mid + 10}`].forEach((d) => {
          draw(svg, 'path', { d, fill: 'none', stroke: shade(cord, '#000000', 0.45), 'stroke-width': 8.6, 'stroke-linecap': 'round' });
          draw(svg, 'path', { d, fill: 'none', stroke: cord, 'stroke-width': 6.4, 'stroke-linecap': 'round' });
          draw(svg, 'path', { d, fill: 'none', stroke: shade(cord, '#ffffff', 0.5), 'stroke-width': 1.5, 'stroke-dasharray': '2.2 2.8', 'stroke-linecap': 'round' });
        });
        ring(left, mid, 3);
        ring(right, mid, 3);
      }
      if (shape && shape.path) {
        const g = draw(svg, 'g', { transform: `translate(${charm.x} ${charm.y}) scale(${k})` });
        draw(g, 'path', { d: shape.path, fill: metal, 'fill-rule': 'evenodd' });
      } else if (image) {
        draw(svg, 'image', { href: image, x: 100 - area.w / 2, y: area.y, width: area.w, height: area.h, preserveAspectRatio: 'xMidYMid meet' });
      } else {
        const g = draw(svg, 'g', { transform: `translate(70 ${area.y + 6}) scale(2.5)`, fill: metal });
        g.innerHTML = PAW.replace(/^<svg[^>]*>|<\/svg>$/g, '');
      }
      return svg;
    }

    // the finishes of a piece that can still be bought (a bracelet needs one cord left in it)
    function buyable(shop) {
      const sold = new Set(shop.sold || []);
      return shop.finish.filter((f) => (shop.cord.length ? shop.cord.some((c) => !sold.has(`${f} / ${c}`)) : !sold.has(f)));
    }

    // a colour pushed toward black or white
    function shade(hex, to, t) {
      const a = parseInt(hex.slice(1), 16);
      const b = parseInt(to.slice(1), 16);
      const c = (shift) => Math.round(((a >> shift) & 255) * (1 - t) + ((b >> shift) & 255) * t);
      return `rgb(${c(16)} ${c(8)} ${c(0)})`;
    }

    function draw(parent, name, attrs) {
      const node = document.createElementNS(SVG_NS, name);
      for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, String(v));
      parent.append(node);
      return node;
    }

    function icon(kind) {
      const span = el('span', 'pawbau-track__icon');
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = {
        gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M2.5 9h19M12 9v11M12 9c-1.5-3-5-4-5-1.5S11 9 12 9zm0 0c1.5-3 5-4 5-1.5S13 9 12 9z"/></svg>',
        shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.2-7.5 9.5-4.3-1.3-7.5-4.9-7.5-9.5V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
        paw: PAW,
      }[kind] || '';
      return span;
    }

    // — small things ———————————————————————————————————————————

    function el(tag, className) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      return node;
    }

    function text(tag, className, value) {
      const node = el(tag, className);
      node.textContent = value;
      return node;
    }

    function links(tracking) {
      const wrap = el('p', 'pawbau-track__links');
      (tracking || []).forEach((t) => {
        const a = document.createElement('a');
        a.href = t.url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = `Track with USPS · ${t.number}`;
        wrap.append(a);
      });
      return wrap;
    }

    // 4h 12m, 35m
    function duration(ms) {
      const minutes = Math.max(1, Math.ceil(ms / 60000));
      const h = Math.floor(minutes / 60);
      return h ? `${h}h ${minutes % 60}m` : `${minutes}m`;
    }

    // the calendar day of a moment in the shop's time zone, as a plain UTC date
    function shopDay(date, zone) {
      try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone || 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
        const get = (type) => Number(parts.find((p) => p.type === type)?.value);
        return Date.UTC(get('year'), get('month') - 1, get('day'));
      } catch {
        return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
      }
    }

    function nextWorking(time, holidays) {
      for (;;) {
        const d = new Date(time);
        if (d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !holidays.has(d.toISOString().slice(0, 10))) return time;
        time += DAY;
      }
    }

    // "Nov 11 – 14", "Oct 30 – Nov 2"
    function range(from, to) {
      const month = (t) => new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(new Date(t));
      const day = (t) => new Date(t).getUTCDate();
      return month(from) === month(to) ? `${month(from)} ${day(from)} – ${day(to)}` : `${month(from)} ${day(from)} – ${month(to)} ${day(to)}`;
    }

    customElements.define('pawbau-track-order', PawbauTrackOrder);
  })();

  } catch(e) { console.error(e); }
})();
})();
